import {
  faGithub,
  faLinkedin,
  faMedium,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

export const socialMediaItems = [
  {
    id: "github",
    name: "GitHub",
    icon: faGithub,
    link: "https://github.com/Sumansourabh14",
  },
  {
    id: "linkedin",
    name: "LinkedIn",
    icon: faLinkedin,
    link: "https://www.linkedin.com/in/sumansourabh14",
  },
  {
    id: "twitter",
    name: "Twitter",
    icon: faTwitter,
    link: "https://x.com/sumansourabh48",
  },
  {
    id: "medium",
    name: "Medium",
    icon: faMedium,
    link: "https://medium.com/@sumsourabh14",
  },
];
